import { render, staticRenderFns } from "./catalog-image.vue?vue&type=template&id=5f3903c6&scoped=true&"
import script from "./catalog-image.vue?vue&type=script&lang=js&"
export * from "./catalog-image.vue?vue&type=script&lang=js&"
import style0 from "./catalog-image.vue?vue&type=style&index=0&id=5f3903c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3903c6",
  null
  
)

export default component.exports